<template>
  <div class="archive20251212" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} 国際会議NLPIR2025 参加報告</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">2025年12月12日から13日に開催された国際会議NLPIR2025に参加し，口頭発表しました．</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">
                発表題目：「What Makes a Review Helpful? A Feature-driven Study」<br>
                発表題目：「Construction of a Stress Estimation Model Using Multimodal Features」
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20251212.png`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>
